module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 028.92909317.jpg";